<template>
  <div>
    <RecruitNav/>
    <body class="main-body">
      <div class="flex-container" id="chat">
        <div class="company-header">
          <p><i @click="clickBrowserBack" class="mdi mdi-chevron-left chevron-left"></i></p>
          <p>
            <i
              class="mdi mdi-menu icon-menu"
              @click="clickDrawerMenu"
              v-if="!drawerFlg">
            </i>
            <i @click="clickDrawerMenu" class="mdi mdi-close close" v-if="drawerFlg"></i>
          </p>
          <h1>{{widgetData.companyName}}</h1>
        </div>
        <div style="position: fixed; z-index: 1000; width: 100vw; height: 100vh; border-bottom-right-radius: 10px; border-bottom-left-radius: 10px; background: white; top: 0; left: 0;" v-if="!isMessage">
          <Loading/>
        </div>
        <!-- チャット画面 -->
        <div class="main-container"
          @click="nextScenario()"
          @touchstart="onTouchStart($event)"
          @touchmove="onTouchMove($event)"
          @touchend="onTouchEnd()"        
        >
          <div @click="clickDrawerMenu" :class="{ filter: drawerFlg }"></div>
          <div style="width: 100%; height: 100%; padding: 16px; position: absolute; background: #f8f8f8ee; z-index: 999;" v-if="!isOnLine || ws==null">
            現在接続がされておりません。<br>
            すぐに再接続しますか？<br>
            （自動でも再接続されます）<br><br>
            <a class="button is-primary" @click="reconnect()">再接続する</a>
          </div>
          <div style="width: 100%; height: 100%; padding: 16px; position: absolute; background: #f8f8f8ee; z-index: 999;" v-else-if="!chatbot.is_confirm">
            現在メンテナンス中です。
          </div>
          <div style="width: 100%; height: 100%; padding: 16px; position: absolute; background: #f8f8f8ee; z-index: 999;" v-else-if="this.lastView">
            以前にこのロボとやりとりしたことがあります。<br>
            続きから再開しますか？<br><br>
            <a class="button is-primary" @click="scenarioStart('top')">最初から始める</a>
            <a class="button is-primary" @click="scenarioStart('continue')">続きから始める</a>
          </div>
          <div class="chat-dialog">
            <Balloon
              v-for="(chat,index) in chatLogs" :key="index"
              :speaker="chat.speaker"
              :name="chat.name"
              :icon="chat.icon"
              :message="chat.message"
              :time="displayDate(chat)"
              :readTime="new Date(widgetData.readTime)"
              :isBot="chat.isBot"
              :email="chat.email"
              :isManager="chat.isManager"
              :logIndex="index"
              :lastIndex="chatLogs.length - 1"
              :files="chat.files"
              :filename="chat.filename"
              :status="chat.status"
              :parameter="chat.parameter"
              :companyData="widgetData"
              :roboPartsSetOutsideScenario="roboPartsSetOutsideScenario"
              :roboPartsSetNextNode="roboPartsSetNextNode"
              @setLocalStorage="setLocalStorage">
            </Balloon>
            <MogoMogo v-if="isTyping||isSCNLoading||isRecommendScheduleLoading||messageLoading"/>
            <div style="height: 42px; width: 200px;" v-else></div>
            <div style="color: #333; background: rgba(0, 0, 0, 0.2); display: flex;" v-if="(chatLogs[chatLogs.length-1].status == 2||chatLogs[chatLogs.length-1].status == 5||chatLogs[chatLogs.length-1].status == 14||chatLogs[chatLogs.length-1].status == 19)&&!isOnceNavi">
              <div style="padding: 8px 16px;"><span class="mdi mdi-gesture-double-tap mdi-36px"></span></div>
              <div style="padding: 8px 16px 8px 0px; display: flex; justify-content: center; align-items: center;">タップ / クリックで次の会話へと進めることができます。</div>
            </div>
          </div>
          <!-- responsive -->
          <transition name="right">
            <div class="article-container responsive" v-if="drawerFlg">
              <article>
                <h2 class="item-name"><span>他のロボも見てみる</span></h2>
                <b-carousel :autoplay="false" v-if="recommendBots.length > 0">
                  <b-carousel-item v-for="(r, i) in recommendBots" :key="i" style="display: flex; justify-content: center; align-items: center;">
                      <section class="article-box">
                        <div class="img-icon">
                          <img :src="r.icon_data" v-if="r.icon_data">
                          <img src="@/assets/template/robot.png" v-else>
                        </div>
                        <div class="desc-box" @click="getBotURL(r)">
                          <h1><b>{{r.display_name}}</b></h1>
                          <p>{{widgetData.companyName}}</p>
                        </div>
                      </section>
                  </b-carousel-item>           
                </b-carousel>
              </article>
              <article>
                <h2 class="item-name"><span>{{widgetData.companyName}}の求人を見てみる</span></h2>
                <b-carousel :autoplay="false" :indicator-inside="false" v-if="recommendContents.length > 0" style="padding: 0; background: rgba(0, 0, 0, 0.5);">
                  <b-carousel-item v-for="(r, i2) in recommendContents" :key="i2">
                      <section class="article-box" style="padding: 0; height: 300px; align-items: flex-end;" :style="{background: getBackgroundImage(r), 'background-size': 'cover'}">
                        <div class="desc-box-recruit" @click="getRecruitPageURL(r)">
                          <h1><b>{{r.content.title}}</b></h1>
                          <p><span class="mdi mdi-office-building" style="margin-right: 4px;"></span>{{subStrMessage(widgetData.companyName, 30)}}</p>
                          <p>
                            <span class="mdi mdi-briefcase"  style="margin-right: 4px;"></span>{{subStrMessage(r.content.work_title, 30)}}
                            <span class="mdi mdi-map-marker" style="margin-right: 4px;"></span>{{subStrMessage(r.content.google_map, 15)}}
                          </p>
                        </div>
                      </section>
                  </b-carousel-item>           
                </b-carousel>
              </article>
              <article>
                <h2 class="item-name"><span>他のおすすめロボ</span></h2>
                <b-carousel :autoplay="false" v-if="recommendBotsOther.length > 0" style="background: #f0f0f0; border: solid thin #ccc;">
                  <b-carousel-item v-for="(r, i3) in recommendBotsOther" :key="i3">
                      <section class="article-box">
                        <div class="img-icon">
                          <img :src="r.icon_data" v-if="r.icon_data">
                          <img src="@/assets/template/robot.png" v-else>
                        </div>
                        <div class="desc-box" @click="getBotURL(r)">
                          <h1><b>{{r.display_name}}</b></h1>
                          <p>他社のロボものぞいて見ましょう！</p>
                        </div>
                      </section>
                  </b-carousel-item>           
                </b-carousel>
              </article>
            </div>
          </transition>
          <!-- responsive ここまで -->
        </div>
      </div>
      <!-- pc -->
      <div class="article-container pc">
        <article>
          <h2 class="item-name"><span>他のロボも見てみる</span></h2>
          <b-carousel :autoplay="false" v-if="recommendBots.length > 0">
            <b-carousel-item v-for="(r, i) in recommendBots" :key="i" style="display: flex; justify-content: center; align-items: center;">
                <section class="article-box">
                  <div class="img-icon">
                    <img :src="r.icon_data" v-if="r.icon_data">
                    <img src="@/assets/template/robot.png" v-else>
                  </div>
                  <div class="desc-box" @click="getBotURL(r)">
                    <h1><b>{{r.display_name}}</b></h1>
                    <p>{{widgetData.companyName}}</p>
                  </div>
                </section>
            </b-carousel-item>           
          </b-carousel>
        </article>
        <article>
          <h2 class="item-name"><span>{{widgetData.companyName}}の求人を見てみる</span></h2>
          <b-carousel :autoplay="false" :indicator-inside="false" v-if="recommendContents.length > 0" style="padding: 0; background: rgba(0, 0, 0, 0.5);">
            <b-carousel-item v-for="(r, i2) in recommendContents" :key="i2">
                <section class="article-box" style="padding: 0; height: 300px; align-items: flex-end;" :style="{background: getBackgroundImage(r), 'background-size': 'cover'}">
                  <div class="desc-box-recruit" @click="getRecruitPageURL(r)">
                    <h1><b>{{r.content.title}}</b></h1>
                    <p><span class="mdi mdi-office-building" style="margin-right: 4px;"></span>{{subStrMessage(widgetData.companyName, 30)}}</p>
                    <p>
                      <span class="mdi mdi-briefcase"  style="margin-right: 4px;"></span>{{subStrMessage(r.content.work_title, 30)}}
                      <span class="mdi mdi-map-marker" style="margin-right: 4px;"></span>{{subStrMessage(r.content.google_map, 15)}}
                    </p>
                  </div>
                </section>
            </b-carousel-item>           
          </b-carousel>
        </article>
        <article>
          <h2 class="item-name"><span>他のおすすめロボ</span></h2>
          <b-carousel :autoplay="false" v-if="recommendBotsOther.length > 0" style="background: #f0f0f0; border: solid thin #ccc;">
            <b-carousel-item v-for="(r, i3) in recommendBotsOther" :key="i3">
                <section class="article-box">
                  <div class="img-icon">
                    <img :src="r.icon_data" v-if="r.icon_data">
                    <img src="@/assets/template/robot.png" v-else>
                  </div>
                  <div class="desc-box" @click="getBotURL(r)">
                    <h1><b>{{r.display_name}}</b></h1>
                    <p>他社のロボものぞいて見ましょう！</p>
                  </div>
                </section>
            </b-carousel-item>           
          </b-carousel>
        </article>
      </div>
      <!-- pc ここまで -->
    </body>
  </div>
</template>

<script>
import RecruitNav from '@/views/Recruit/RecruitNav'
import Balloon from '@/components/ui/Balloon'
import MogoMogo from '@/components/ui/MogoMogo'
import Loading from '@/components/animations/Loading'
import watchScenarioMixin from '@/mixins/watchScenarioMixin'
import connectCheckMixin from '@/mixins/connectCheckMixin'
import { mapState } from 'vuex'
import _ from 'lodash'
import resetLocalStorageSeeker from '@/functions/resetLocalStorageSeeker'
export default {
  name: 'ChatBotView',
  componentName: 'ChatBotView',
  components: {
    Loading,
    Balloon,
    MogoMogo,
    RecruitNav
  },
  mixins: [watchScenarioMixin, connectCheckMixin],
  data () {
    return {
      isDemo: false,
      weekday: [
        '日', '月', '火', '水', '木', '金', '土'
      ],
      isMessage: false,
      isTyping: '',
      isTypingScroll: false,
      isMobileInput: false,
      height: 45,
      flex: 0.5,
      num: null,
      companyid: null,
      botid: null,
      userData: {
        url: null,
        appname: null,
        platform: null,
        width: null,
        height: null,
        color: null,
        referrer: null,
        useragent: null,
        ckey: null,
        cookies: null,
        sessionid: null,
        count: null
      },
      chatbot: null,
      isShowMenu: false,
      drawerFlg: false,
      isOnceNavi: false,
      chatLen: false,
      // スワイプでドロワーメニューをtoggleするためのdata
      swipe: {
        flag: false,
        threshold: 60,
        start: {
          x: 0
        },
        current: {
          x: 0
        },
        distance: {
          x: 0
        },
      },
    }
  },
  computed: {
    ...mapState('auth', ['user', 'isUser', 'token']),
    ...mapState('directtalk', ['chatLogs', 'seeker', 'data', 'chatData', 'widgetData', 'typing', 'mobileKey', 'color', 'power', 'own', 'messagePages', 'isChatLogs', 'ws', 'messageLoading', 'targetID', 'target', 'targetIcon']),
    ...mapState('chatbot', ['scenarioTable', 'isSwitch', 'scenario', 'isSCNLoading', 'recommendBots', 'recommendBotsOther', 'minipk', 'lastView', 'roboPartsSetOutsideScenario', 'roboPartsSetNextNode']),
    ...mapState('calendar', ['schedule', 'recommendDate', 'isRecommendScheduleLoading']),
    ...mapState('employmentPage', ['recommendContents', 'recommendContentsOther']),
  },
  mounted () {
    // 訪問者情報の割当
    this.userData.url = location.href
    this.userData.appname = window.navigator.appName
    this.userData.platform = window.navigator.platform
    this.userData.width = window.screen.width
    this.userData.height = window.screen.height
    this.userData.color = window.screen.colorDepth
    this.userData.referrer = document.referrer
    this.userData.useragent = window.navigator.userAgent
    this.userData.ckey = this.$route.params.companyid
    this.userData.cookies = document.cookie
    this.userData.sessionid = localStorage.getItem('SID_' + this.$route.params.companyid)
    this.userData.count = localStorage.getItem('CNT_' + this.$route.params.botid)
    this.companyid = this.$route.params.companyid
    this.botid = this.$route.params.botid
    this.$store.dispatch('chatbot/setMiniPK', this.$route.params.minipk)
    this.$store.dispatch('chatbot/getRecommendBot', {cid: this.companyid, botid: this.botid})
    this.$store.dispatch('employmentPage/getRecommendContents', this.companyid)
    this.$store.dispatch('directtalk/setJson', this.userData)
    var vm = this
    document.addEventListener('DOMFocusIn', function (event) {
      // キーボードが出現した時
      vm.$store.dispatch('directtalk/mobileType')
    }, false)
    document.addEventListener('DOMFocusOut', function (event) {
      // キーボードが引っ込んだ時
      vm.$store.dispatch('directtalk/mobileType')
    }, false)
    document.addEventListener('visibilitychange', this.handleVisibilityChange, false)
    window.addEventListener('resize', () => {
      let vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    })
  },
  watch: {
    isMessageError () {
      if (this.ws == null) {
        var uri = process.env.WS_ENDPOINT + this.data.ckey + '/' + this.seeker.id + '/'
        this.$store.dispatch('directtalk/connect', {uri: uri, category: 'widget'})
      }
    },
    'seeker.id' () {
      var uri = process.env.WS_ENDPOINT + this.data.ckey + '/' + this.seeker.id + '/'
      localStorage.setItem('SID_' + this.$route.params.companyid, this.seeker.id)
      localStorage.setItem('CNT_' + this.$route.params.botid, this.seeker.count)
      localStorage.setItem('SCR', 0)
      this.$store.dispatch('directtalk/getMessage', {name: 'seeker', pages: this.messagePages})
      this.$store.dispatch('directtalk/connect', {uri: uri, category: 'widget'})
      this.$store.dispatch('directtalk/getRoom')
    },
    async 'widgetData.name' () {
      this.isMessage = true
      let bot_info = await this.$store.dispatch('directtalk/getRoboInfo', {'robo_id': this.botid})
      if (bot_info) {
        this.$store.dispatch('auth/slackPost', {companyID: this.data.ckey, seekerID: this.seeker.id, msg: ''})
        this.$store.dispatch('auth/CWPost', {companyID: this.data.ckey, seekerID: this.seeker.id, msg: ''})
        this.chatbot = bot_info
      }
    },
    typing () {
      if (this.typing.indexOf('start_typing:') !== -1) {
        this.isTyping = '入力中...'
        if (!this.isTypingScroll) {
          this.isTypingScroll = true
          this.$nextTick(() => {this.scrollDown()})
        }
      } else if (this.typing.indexOf('end_typing:') !== -1) {
        this.isTyping = ''
        this.isTypingScroll = false
      }
    },
    isSCNLoading () {
      if (this.isSCNLoading) {
        this.isTypingScroll = true
        this.$nextTick(() => {this.scrollDown()})
      } else {
        this.isTypingScroll = false
      }
    },
    recommendDate () {
      this.pushScenarioCalendar()
    },
    'chatData.message' () {
      if (this.chatData.message !== '') {
        this.$store.dispatch('directtalk/isTyping', 'start_typing@seeker')
        this.num = this.chatData.message.match(/\r\n|\n/g)
        if (this.num != null) {
          this.flex = 1.30
          this.height = 90
        } else {
          this.flex = 0.5
          this.height = 45
        }
      } else {
        this.$store.dispatch('directtalk/isTyping', 'end_typing@seeker')
        this.num = this.chatData.message.match(/\r\n|\n/g)
        if (this.num != null) {
          this.flex = 1.30
          this.height = 90
        } else {
          this.flex = 0.5
          this.height = 45
        }
      }
    },
    chatLogs () {
      this.chatLen = false
      if (this.chatLogs.length !== 0) {
        this.$nextTick(() => {this.scrollDown()})
      }
    },
    chatbot () {
      // 各種アクションの履歴テーブル登録
      this.$store.dispatch('directtalk/createSeekerATHistory', {target: this.chatbot.name, action: 'click_room_link', url: this.data.url, element: 'button'})
      this.$store.dispatch('directtalk/setDT', {name: this.chatbot.display_name, icon: this.chatbot.icon_data, id: this.chatbot.bot_id, model: 'bot'})
      this.$store.dispatch('chatbot/setMiniPK', this.chatbot.pk || null)
      let id = this.chatbot.pk || this.chatbot.bot_id
      let lv = localStorage.getItem('scenariolv_' + id)
      if (lv) {
        lv = JSON.parse(lv)
        if (lv.node == '') {
          lv = null
          localStorage.removeItem('scenariolv_' + id)
        }
      }
      if (!lv) {
        resetLocalStorageSeeker(this.seeker.id)
        this.$store.dispatch('chatbot/getScenarioOne', { companyid: this.data.ckey, scenarioName: this.chatbot.scenario_name, node: 'INITIALIZE', rate: this.color.thinking_rate, minipk: this.$route.params.minipk ? this.$route.params.minipk : null})
      }
      this.$store.commit('chatbot/SET_LAST_VIEW', lv)
    }
  },
  methods: {
    getOwnURL (path) {
      return process.env.OWN_ENDPOINT + path
    },
    getWDTURL (path) {
      return process.env.WDT_ENDPOINT + path
    },
    getBotURL (bot) {
      if (bot.pk) {
        location.href = process.env.OWN_ENDPOINT + '/recruits/bot/' + bot.group + '/' + bot.bot_id + '/' + bot.pk
      } else {
        location.href = process.env.OWN_ENDPOINT + '/recruits/bot/' + bot.group + '/' + bot.bot_id
      }
    },
    getRecruitPageURL (recruit) {
      location.href = process.env.WDT_ENDPOINT + '/recruit/detail/' + recruit.company_id + '/' +  recruit.contents_id
    },
    getBackgroundImage (content) {
      var defaultURL = require('@/assets/template/default_recruit.jpg')
      if (content.image && content.is_image_original) {
        return 'url(\"' + content.image + '\") center center no-repeat'
      } else if (content.image_url && !content.is_image_original) {
        return 'url(\"' + content.image_url + '\") center center no-repeat'
      } else {
        return 'url(\"' + defaultURL + '\") center center no-repeat'
      }
    },
    subStrMessage (text, len) {
      if (!text) return '-'
      else return text.length < len ? text : text.substring(0, len) + '...'
    },
    reconnect () {
      if (this.ws == null) {
        // 再接続
        var uri = process.env.WS_ENDPOINT + this.data.ckey + '/' + this.seeker.id + '/'
        this.$store.dispatch('directtalk/connect', {uri: uri, category: 'widget'})
      }
    },
    scenarioStart (position) {
      if (position == 'top') {
        resetLocalStorageSeeker(this.seeker.id)
        this.$store.dispatch('chatbot/getScenarioOne', { companyid: this.data.ckey, scenarioName: this.chatbot.scenario_name, node: 'INITIALIZE', rate: this.color.thinking_rate, minipk: this.$route.params.minipk ? this.$route.params.minipk : null})
        let id = this.$route.params.minipk || this.targetID
        localStorage.removeItem('scenariolv_' + id)
      }
      else if (position == 'continue') {
        if (this.lastView.isPartsSet) {
          this.$store.dispatch('chatbot/setRoboPartsSetInside', {name: this.chatbot.scenario_name, node: this.lastView.partsSetOutsideNextNode})
        }
        this.$store.dispatch('chatbot/getScenarioOne', {
          companyid: this.data.ckey,
          scenarioName: this.lastView.isPartsSet ? 'parts-set' : this.chatbot.scenario_name,
          node: this.lastView.node,
          rate: this.color.thinking_rate,
          minipk: this.$route.params.minipk ? this.$route.params.minipk : null})
      }
      this.$store.commit('chatbot/SET_LAST_VIEW', null)
    },
    getCalendar () {
      let param = _.cloneDeep(this.scenario.parameter)
      // 開始日を計算
      let now = new Date()
      now = new Date(now.setSeconds(0))
      now = new Date(now.setHours(param.work_time_start))
      now = new Date(now.setMinutes((param.work_time_start * 100) - (now.getHours() * 100)))
      let nextDay = new Date(now.setDate(new Date().getDate() + param.after))
      param.after = nextDay.toLocaleString('ja-JP')
      this.$store.dispatch('calendar/getRecommendSchedule', param)
    },
    pushScenario () {
      var scenarioData = this.makeScenario()
      this.$store.dispatch('directtalk/pushChat', scenarioData)
      this.$store.dispatch('directtalk/createSeekerATHistory', {target: scenarioData.email, action: 'send_scn', url: this.data.url, element: this.scenario.beforenode})
    },
    pushScenarioCalendar () {
      var scenarioData = this.makeScenarioCalendar()
      this.$store.dispatch('directtalk/pushChat', scenarioData)
      this.$store.dispatch('directtalk/createSeekerATHistory', {target: scenarioData.email, action: 'send_scn', url: this.data.url, element: this.scenario.beforenode})
    },
    nextScenario () {
      if (!this.chatLen && !this.messageLoading && !this.isSCNLoading && this.chatLogs[this.chatLogs.length-1].status == 2 || this.chatLogs[this.chatLogs.length-1].status == 5||this.chatLogs[this.chatLogs.length-1].status == 14||this.chatLogs[this.chatLogs.length-1].status == 19) {
        this.isOnceNavi = true
        this.chatLen = true
        let scenarioName = null
        let nextNode = null
        if (this.scenario.output_flg === true) {
          scenarioName = this.roboPartsSetOutsideScenario
          nextNode = this.roboPartsSetNextNode
        } else {
          scenarioName = this.scenario.name
          nextNode = this.scenario.select[0].next_node
        }
        this.$store.dispatch('chatbot/getScenarioOne', { companyid: this.data.ckey, scenarioName: scenarioName, node: nextNode, rate: this.color.thinking_rate, minipk: this.minipk})
        localStorage.setItem(
          'scenariolv_' + (this.minipk || this.targetID),
          JSON.stringify({
            node: nextNode,
            date: Date().toString(),
            isPartsSet: scenarioName == 'parts-set',
            partsSetOutsideNextNode: scenarioName == 'parts-set' ? this.roboPartsSetNextNode : ''
          }))
      }
    },
    makeScenario () {
      var name = ''
      var id = ''
      var icon = ''
      name = this.target
      id = this.targetID
      icon = this.targetIcon
      var msg = ''
      if (this.scenario.status == 5) {
        msg = '[msg][image]' + this.scenario.image + '[/image][/msg]|' + this.scenario.template
      } else if (this.scenario.status == 14) {
        msg = '[msg][movie]' + this.scenario.movie + '[/movie][/msg]' + this.scenario.template
      } else {
        msg = '[msg]' + this.scenario.mainmessage + '[/msg]|' + this.scenario.template
      }
      var scenarioData = {
        message: msg,
        name: name,
        url: this.data.url,
        email: id,
        speaker: 'other',
        icon: icon,
        createdAt: new Date().toISOString(),
        sendToID: this.seeker.id,
        minibot_pk: this.minipk ? this.minipk : '',
        sendToModel: '',
        scenarioName: this.scenario.name,
        scenarioNode: this.scenario.beforenode,
        btnIdx: 0,
        isManager: '2',
        appname: '',
        platform: '',
        refferer: '',
        useragent: '',
        count: 0,
        status: this.scenario.status,
        parameter: this.scenario.parameter,
      }
      return scenarioData
    },
    makeScenarioCalendar () {
      var name = ''
      var id = ''
      var icon = ''
      // ロボを切り替える場合はシナリオ読み込み一回以上している状態
      name = this.target
      id = this.targetID
      icon = this.targetIcon
      var templateDate = ''
      if (this.recommendDate.start !== 'Initialized') {
        const buttonTagS = '[button]'
        const buttonTagE = '[/button]'
        const pipe = '|'
        // alert(JSON.stringify(this.recommendDate))
        for (let i=0; i<this.recommendDate.length; i++) {
          const recDate =
            new Date(this.recommendDate[i].start).getMonth() + 1 + '/' + new Date(this.recommendDate[i].start).getDate() + ' (' +  this.weekday[new Date(this.recommendDate[i].start).getDay()] + ') ' +
            new Date(this.recommendDate[i].start).getHours() +     ':' + ('00' + new Date(this.recommendDate[i].start).getMinutes()).slice(-2) + ' ~ ' +
            new Date(this.recommendDate[i].end).getHours()   +     ':' + ('00' + new Date(this.recommendDate[i].end).getMinutes()).slice(-2)
          templateDate += pipe + buttonTagS + recDate + buttonTagE
        }
      }
      var scenarioData = {
        message: '[msg]' + this.scenario.mainmessage + '[/msg]' + templateDate,
        name: name,
        url: this.data.url,
        email: id,
        speaker: 'other',
        icon: icon,
        createdAt: new Date().toISOString(),
        sendToID: this.seeker.id,
        minibot_pk: this.minipk ? this.minipk : '',
        sendToModel: '',
        scenarioNode: this.scenario.beforenode,
        btnIdx: 0,
        isManager: '2',
        appname: '',
        platform: '',
        refferer: '',
        useragent: '',
        count: 0,
        status: this.scenario.status,
        parameter: this.scenario.parameter,
      }
      return scenarioData
    },
    submit () {
      var w = this.data
      this.chatData.name = this.widgetData.name
      this.chatData.url = w.url
      if (this.chatData.message !== '') {
        this.chatData.email = ''
        var today = new Date()
        this.chatData.createdAt = today.toISOString()
        this.chatData.isManager = '0'
        this.chatData.sendToID = this.chatbot.bot_id
        this.chatData.minibot_pk = this.minipk ? this.minipk : ''
        this.chatData.sendToModel = 'input'
        this.chatData.scenarioName = this.scenario.name
        this.chatData.scenarioNode = this.scenario.beforenode
        this.chatData.btnIdx = 0
        this.chatData.status = this.scenario.status
        this.chatData.parameter = this.scenario.parameter
        var promise = Promise.resolve()
        promise
          .then(this.$store.dispatch('auth/slackPost', {companyID: this.data.ckey, seekerID: this.seeker.id, msg: this.chatData.message}))
          .then(this.$store.dispatch('auth/CWPost', {companyID: this.data.ckey, seekerID: this.seeker.id, msg: this.chatData.message}))
          .then(this.$store.dispatch('directtalk/pushChat', this.chatData))
          .then(this.chatData.message = '')
      }
    },
    scrollDown () {
      var target = document.querySelector('.chat-dialog')
      if (!target) return
      target.scrollTop = target.scrollHeight
    },
    clickBrowserBack () {
      window.history.back();
    },
    clickDrawerMenu () {
      this.drawerFlg = !this.drawerFlg
    },
    onTouchStart (e) {
      this.swipe.flag = true;
      this.swipe.start.x = e.touches[0].pageX;
    },
    onTouchMove (e) {
      this.swipe.current.x = e.touches[0].pageX;
      this.swipe.distance.x = this.swipe.current.x - this.swipe.start.x;
      // 右スワイプ
      if(this.swipe.flag && this.swipe.distance.x > 0 && this.swipe.distance.x >= this.swipe.threshold) {
        if (this.drawerFlg) {
          this.clickDrawerMenu()
        }
        this.swipe.flag = false
      }
      // 左スワイプ
      if (this.swipe.flag && this.swipe.distance.x < 0 && this.swipe.distance.x >= this.swipe.threshold * -1) {
        if (!this.drawerFlg) {
          this.clickDrawerMenu()
        }
        this.swipe.flag = false
      }
    },
    onTouchEnd () {
      this.swipe.flag = false
    },
    setLocalStorage (value) {
      localStorage.setItem('scenariolv_' + (this.minipk || this.targetID), value)
    },
    displayDate(chat) {
      if (!isNaN(chat.createdAt)) {
        return new Date(chat.createdAt)
      } else {
        return new Date(chat.createdAtOther)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
html, body {
  width: 100vw;
  height: 100vh;
}
h1 {
  font-size: medium;
  font-weight: 600;
  overflow-x: scroll;
}
.main-body {
  display: flex;
  flex-wrap: wrap;
}
.header-recruit {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #f8f8f8;
    width: 100%;
    height: 80px;
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #9E9E9E;
}
.title-container >  a{
    display: flex;
    color: #4a4a4a;
}
.logo-wrapper > img {
    width: 40px;
    height: auto;
}
.logo-title {
    display: flex;
    margin-left: 4px;
    align-items: center;
    font-size: 22px;
    font-weight: bold;
}
.flex-container {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.main-container {
  display: flex;
  flex-direction: column;
  height: calc(100% - 50px);
  position: relative;
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
}
.article-container {
  width: 50%;
  height: calc(100vh - 80px);
  padding-bottom: 24px;
  overflow-y: scroll;
}
.article-container::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  visibility: hidden;
}
.article-container > .item-name {
  height: auto;
  padding: 16px 0 16px 8px;
  overflow: hidden;
}
.loading-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
}
.company-header{
  background: #f8f8f8;
  height: 50px;
  display: flex;
  justify-content: center;
  flex-direction: column-reverse;
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
  position: relative;
}
.chat-dialog {
  height: calc(100% - 80px);
  overflow-x: hidden;
  overflow-y: scroll;
  scroll-behavior: smooth;
  background-color: #fff;
}
.chat-dialog::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.input-button {
  background: transparent;
  border: none;
  resize: none;
  outline:none;
}

.parent-form {
  width: 100%;
  background: #F8F8F8;
  border-top: solid thin #CCC;
}
.child-form {
  text-align: center;
  padding-bottom: 0px !important;
  min-height: 45px;
  background: #F8F8F8;
}
textarea {
  min-width: calc(100% - 40px);
  max-width: calc(100% - 40px);
  font-size: 18px;
  border: none;
  resize: none;
  outline:none;
  line-height: 25px;
  padding-top: 10px;
  padding-left: 8px;
}
.loading-form {
  height: 20px;
  background-color: transparent;
  font-size: 16px;
}
.loading span {
  display: inline-block;
  margin: 0 -.05em;
  margin-left: 10px;
  animation: loading .7s infinite;
}
.loading span:nth-child(2) {
  animation-delay: .1s;
}
.loading span:nth-child(3) {
  animation-delay: .2s;
}
.loading span:nth-child(4) {
  animation-delay: .3s;
}
.loading span:nth-child(5) {
  animation-delay: .4s;
}
.loading span:nth-child(6) {
  animation-delay: .5s;
}
.loading span:nth-child(7) {
  animation-delay: .6s;
}
@keyframes loading {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}
.list {
  height: 80vh;
}
.chat-list-enter-active, .chat-list-leave-active {
  transition: all 1s;
}
.chat-list-enter, .chat-list-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.mogomogo-enter-active, .mogomogo-leave-active {
  transition: all 1s;
}
.mogomogo-enter, .mogomogo-leave-to {
  position: absolute;
  transform: scale(0);
}

.article-container h2 {
  font-size: medium;
  text-align: left;
  font-weight: 600;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 16px 8px;
  overflow-x: scroll;
}
.article-container h2 span {
  display: inline-block;
  background: linear-gradient(transparent 50%, #FFCCDD 50%);
}
.article-container > div {
  padding: 16px;
  width: calc(100% - 32px);
  margin-left: 16px;
  border: none;
  background-color: #f8f8f8;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1);
}
.article-container > div > div {
  display: flex;
  justify-content: center;
  align-items: center;
}
.article-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  padding: 24px;
}
.user-img-icon {
  height: 64px;
  width: 64px;
  border-radius: 50%;
  background: white;
  cursor: pointer;
  margin-left: 16px;
}
.img-icon > img {
  height: 80px;
  width: 80px;
  object-fit: cover;
  border-radius: 50%;
}
.desc-box {
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
  margin-left: 16px;
  width: calc(100% - 80px);
  max-width: 160px;
  cursor: pointer;
}
.desc-box > h1 {
  font-size: smaller;
  text-align: left;
}
.desc-box > p {
  font-size: smaller;
  color: #666;
  text-align: left;
}
.desc-box-recruit {
  display: flex;
  justify-content: end;
  align-items: start;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  cursor: pointer;
  padding: 16px;
}
.desc-box-recruit > h1 {
  font-size: smaller;
  text-align: left;
  color: #fefefe;
}
.desc-box-recruit > p {
  font-size: smaller;
  color: #666;
  text-align: left;
  color: #fefefe;
}
.mobile-menu {
  display: none;
}
.chevron-left {
  display: none;
}
.icon-menu, .close {
  display: none;  
}
.responsive {
  display: none;
}
@media screen and (max-width: 700px) {
  .header-recruit {
    height: 48px;
  }
  .logo-title {
    display: none;
    font-size: 12px;
  }
  .link-nav p {
    display: none;
    font-size: 10px;
  }
  .link-nav button {
    width: 60px;
    height: 25px;
    font-size: 10px;
  }
  .article-container {
    height: calc(100vh - 96px);
    flex-direction: column;
    position: absolute;
    background-color : #f8f8f8;
    right: 0;
    width: 85vw;
    height: 100%;
  }
  .flex-container {
    width: 100%;
    height: calc(100vh - 48px);
  }
  .chat-dialog {
    height: 100%;
  }
  .mobile-menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 64px;
    background: rgba(0, 0, 0, 0.5);
  }
  .btn-menu-left {
    width: 50%;
    height: 100%;
    background: rgba(0, 0, 0, 0);
    font-size: smaller;
    border: none;
    border-radius: 0;
    border-right: solid thin white;
    color: #f8f8f8;
  }
  .btn-menu-right {
    width: 50%;
    height: 100%;
    background: rgba(0, 0, 0, 0);
    font-size: smaller;
    border: none;
    border-radius: 0;
    border-left: solid thin white;
    color: #f8f8f8;
  }
  .user-img-icon {
    height: 32px;
    width: 32px;
  }
  .article-container > .item-name {
    padding: 24px 0 24px 8px;
  }
  .article-container h2 span {
    background: none;
    text-decoration: underline;
  }
  .pc {
    display: none;
  }
  .responsive {
    display: block;
  }
  .chevron-left {
    display: block;
    font-size: 32px;
    position: absolute;
    left: 0;
    top: 0;    
  }
  .icon-menu, .close {
    display: block;
    font-size: 32px;
    position: absolute;
    right: 0;
    top: 0;       
  }
  .right-enter-active, .right-leave-active {
    transform: translate(0px, 0px);
    transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  }

  .right-enter, .right-leave-to {
    transform: translateX(100vw) translateX(0px);
  }
  .filter {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: #4a4a4a;
    opacity: 0.5;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ChatSinglePage/ChatBotView.vue